import { Component, Vue } from 'vue-property-decorator';
import deviceInfo from "@/modules/Device/Device";
import { BrowserListData } from "@/components/IBAlert/IBAlertFixed/interface";

@Component
export default class AppVersionErrorMessage extends Vue {

	browserList: BrowserListData[] = [
		{
			key: 'chrome',
			icon: 'chrome',
			title: 'Chrome',
			version: 68
		},
		{
			key: 'edge',
			icon: 'edge',
			title: 'Edge',
			version: 68
		},
		{
			key: 'safari',
			icon: 'safari',
			title: 'Safari',
			version: 12
		},
		{
			key: 'firefox',
			icon: 'firefox',
			title: 'Firefox',
			version: 60
		},
		{
			key: 'opera',
			icon: 'opera',
			title: 'Opera',
			version: 55
		},
		// {
		// 	key: 'qq',
		// 	icon: 'qq',
		// 	title: 'QQ Browser',
		// 	version: 13.1
		// },
		// {
		// 	key: 'baidu',
		// 	icon: 'baidu',
		// 	title: 'Baidu Browser',
		// 	version: 13.18
		// },
		// {
		// 	key: 'kaios',
		// 	icon: 'kaios',
		// 	title: 'KaiOS Browser',
		// 	version: 2.5
		// }
	];

	getCurrentBrowserValidVersion(key: string) {
		const searchItem = this.browserList.find(i => i.key === key);

		if (searchItem) return searchItem.version;

		return 0
	}

	getCurrentBrowserValid(key: string) {
		const list = [key, `${key} Browser`]

		return list.includes(deviceInfo.getBrowser)
	}

	get deviceInfoObject() {
		return deviceInfo
	}

	get checkValidBrowser(): boolean {
		return this.isBrowserIE
			|| this.isValidBrowserChrome
			|| this.isValidBrowserEdge
			|| this.isValidBrowserSafari
			|| this.isValidBrowserFirefox
			|| this.isValidBrowserOpera
			|| this.isValidBrowserQQ
			|| this.isValidBrowserBaidu
			|| this.isValidBrowserKaiOS
	}

	get isBrowserIE(): boolean {
		return deviceInfo.isIE;
	}

	get isValidBrowserChrome(): boolean {
		return deviceInfo.isChrome && (this.browserVersion < this.getCurrentBrowserValidVersion('chrome'));
	}

	get isValidBrowserEdge(): boolean {

		return this.getCurrentBrowserValid('Edge') && (this.browserVersion < this.getCurrentBrowserValidVersion('edge'));
	}

	get isValidBrowserSafari(): boolean {
		return deviceInfo.isSafari && (this.browserVersion < this.getCurrentBrowserValidVersion('safari'));
	}

	get isValidBrowserFirefox(): boolean {
		return deviceInfo.isFirefox && (this.browserVersion < this.getCurrentBrowserValidVersion('firefox'));
	}

	get isValidBrowserOpera(): boolean {
		return deviceInfo.isOpera && (this.browserVersion < this.getCurrentBrowserValidVersion('opera'));
	}

	get isValidBrowserQQ(): boolean {
		return this.getCurrentBrowserValid('QQ') && (this.browserVersion < this.getCurrentBrowserValidVersion('qq'));
	}

	get isValidBrowserBaidu(): boolean {
		return this.getCurrentBrowserValid('Baidu') && (this.browserVersion < this.getCurrentBrowserValidVersion('baidu'));
	}

	get isValidBrowserKaiOS() {
		return this.getCurrentBrowserValid('KaiOS') && (this.browserVersion < this.getCurrentBrowserValidVersion('kaios'));
	}

	get browserVersion(): number {
		const regex = /^[^.]+/;

		const match = deviceInfo.browserVersion && deviceInfo.browserVersion.match(regex);

		if (match) return +match[0];

		return 0
	}
}